// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const accountTilesServiceUrl = "api/v1/guest/accountTiles";

export interface AccountTilesDataModel {
    quotesCount: number;
    wishListsCount: number;
    orderHistoryCount: number;
    orderApprovalCount: number;
    savedOrdersCount: number;
    invoiceHistoryCount: number;
    backOrdersCount: number;
    autoDeliveryCount: number;
}

export type AccountTilesExpandType =
    | "quotes"
    | "lists"
    | "orderHistory"
    | "orderApproval"
    | "savedOrders"
    | "invoiceHistory"
    | "backOrder"
    | "autoDelivery";

export interface AccountTilesApiParameter extends ApiParameter {
    expand?: AccountTilesExpandType[];
}

export async function getAccountTilesData(parameter: AccountTilesApiParameter): Promise<AccountTilesDataModel> {
    const accountTilesNumbers = await get<AccountTilesDataModel>(accountTilesServiceUrl, parameter);
    return accountTilesNumbers;
}
